import Page from '@components/Page';
import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { AppBar, Box, styled, Typography } from '@mui/material';
import Image from '@components/Image';
import SvgIconStyle from '@components/SvgIconStyle';
import LogInBox from './LogInBox';
import { styles } from './styles';

const SContainer = styled(AppBar)(({ theme }) => ({
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  backgroundColor: theme.palette.background.default,
}));

type Props = {
  login: () => void;
  errors: { access?: string; concurrent_session?: string };
};

const LogIn: FC<Props> = ({ login, errors }) => {
  const { t } = useLocales();
  return (
    <SContainer>
      <Page title={t('login.sign_in')}>
        <Box sx={styles.generalContainer}>
          <Box width="460px">
            <Image alt="cover" src="/login-overlay.jpg" sx={styles.backgroundImage} />
            <SvgIconStyle src="/icons/ic_logo.svg" sx={styles.logo} />
            <Typography variant="h3" sx={styles.welcomeText}>
              {t('login.welcome')}
            </Typography>
          </Box>
          <LogInBox login={login} errors={errors} />
        </Box>
      </Page>
    </SContainer>
  );
};
export default LogIn;
